import { render, staticRenderFns } from "./login20250105.vue?vue&type=template&id=6fa78ecc&scoped=true"
import script from "./login20250105.vue?vue&type=script&lang=js"
export * from "./login20250105.vue?vue&type=script&lang=js"
import style0 from "./login20250105.vue?vue&type=style&index=0&id=6fa78ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa78ecc",
  null
  
)

export default component.exports